import { render, staticRenderFns } from "./ManageNPCard.vue?vue&type=template&id=5505d40a&scoped=true&"
import script from "./ManageNPCard.vue?vue&type=script&lang=js&"
export * from "./ManageNPCard.vue?vue&type=script&lang=js&"
import style0 from "./ManageNPCard.vue?vue&type=style&index=0&id=5505d40a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505d40a",
  null
  
)

export default component.exports